import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { QUERY_CONFIG } from "@/lib/queryConfig";
import type { DecorationOption } from "../types";

const QUERY_KEY = ["product_decoration_options"] as const;

/**
 * Fetch all configurable decoration options (Studs, Laces, …), ordered by
 * display_order. Mirrors {@link useCustomizationOptionsQuery} — same cache-key
 * convention so the config manager and any consumers stay in sync.
 */
export function useDecorationOptionsQuery() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchDecorationOptions,
    ...QUERY_CONFIG.categories,
  });
}

useDecorationOptionsQuery.QUERY_KEY = QUERY_KEY;

async function fetchDecorationOptions(): Promise<DecorationOption[]> {
  const { data, error } = await supabase
    .from("product_decoration_options")
    .select("*")
    .order("display_order", { ascending: true });

  if (error) throw error;
  return (data ?? []) as DecorationOption[];
}
